import { ArrowUpRight } from "lucide-react";

// Replace with the real App Store listing URL once the app is published
export const APP_STORE_URL = "#";

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
    <path d="M16.37 12.6c-.02-2.3 1.88-3.4 1.96-3.46-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.47.83-.72 0-1.82-.81-2.99-.79-1.54.02-2.96.9-3.75 2.27-1.6 2.78-.41 6.89 1.15 9.14.76 1.1 1.67 2.34 2.86 2.3 1.15-.05 1.58-.74 2.97-.74 1.38 0 1.77.74 2.98.72 1.23-.02 2.01-1.12 2.76-2.23.87-1.28 1.23-2.52 1.25-2.58-.03-.01-2.38-.92-2.4-3.66zM14.1 5.86c.63-.77 1.06-1.83.94-2.89-.91.04-2.02.61-2.67 1.37-.58.67-1.1 1.76-.96 2.8 1.02.08 2.06-.52 2.69-1.28z" />
  </svg>
);

export const StoreButton = ({ id = "hero" }) => (
  <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid={`${id}-app-store-button`}
    className="group inline-flex items-center gap-3 rounded-full bg-[#00E5FF] py-2.5 pl-4 pr-5 text-[#050911] hover:bg-white active:scale-95 transition-[background-color,transform]">
    <AppleIcon />
    <span className="flex flex-col leading-none">
      <span className="font-mono text-[10px] uppercase tracking-[0.15em]">Download on the</span>
      <span className="font-display text-xl font-extrabold uppercase">App Store</span>
    </span>
    <ArrowUpRight className="h-5 w-5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
  </a>
);
